/*
 * @Author: cc
 * @LastEditTime: 2022-03-17 20:22:03
 */
import { useEffect, useState } from "react";
import "./play.scss";
import { fetchPost } from "../../request";
import { useLocation, useHistory } from "react-router-dom";
import { VideoCameraOutlined } from "@ant-design/icons";
import { isPc } from "../../utils/index";
import { message } from "antd";
// 高峰论坛userId
let playInfo = localStorage.getItem('playInfo')
let siteid = playInfo ? JSON.parse(playInfo).liveAccount: '';
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
function Play() {
  const query = useQuery();
  const history = useHistory();
  const liveActivityId = query.get("liveActivityId");
  const liveNum = query.get("liveNum");
  const [videoList, setVideoList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const getLiveVideoList = () => {
    fetchPost(`/shop/live/activity/getLiveVideoList`, {
      liveActivityId,
      liveNum,
    }).then((result) => {
      const { data, code, msg } = result;
      if (code !== 0) {
        message.error(msg);
        history.go(-1);
      } else {
        setVideoList(data);
        initVideo(data[currentIndex].ccVideoId);
      }
    });
  };
  const initVideo = (vid: string) => {
    if (window.createCCH5Player) {
      window.ccPlayerStatus = window.createCCH5Player({
        vid,
        siteid,
        autoStart: true,
        width: isPc ? "80vw" : "100vw",
        height: isPc ? "100vh" : "300px",
        banDrag: "false",
        playtype: 1,
        rate_allow_change: false,
        parentNode: document.getElementById("livePlayer"),
      });
    }
  };
  useEffect(() => {
    getLiveVideoList();
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div
        className={"playInfo_box"}
        style={{
          flexDirection: isPc ? "row" : "column",
        }}
      >
        <div id="livePlayer"></div>
        <div className="video_bottom_box">
          <div>
            <p>
              {videoList.map(
                (item: { title: string; ccVideoId: string }, index: number) => (
                  <div
                    className="classInfo_box"
                    key={index}
                    onClick={() => {
                      setCurrentIndex(index);
                      initVideo(item.ccVideoId);
                    }}
                  >
                    <p>
                      <VideoCameraOutlined />
                      &emsp;
                      <span className={currentIndex === index ? "check" : ""}>
                        {item.title}
                      </span>
                    </p>
                  </div>
                )
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Play;
